import { FC, useState } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";
import Badge from "shared/Badge/Badge";
import moment from "moment";
import { currency } from "functions/redux/general/action";
import NcDropDown from "shared/NcDropDown/NcDropDown";
import { useHistory } from "react-router";
import { getGuideOpenTrip, updateStateTrip } from "functions/redux/listing/action";
import { useDispatch } from "react-redux";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import NcModal from "shared/NcModal/NcModal";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

export interface GuideOpenTripCardProps {
    className?: string;
    ratioClass?: string;
    data?: IProduct | null;
    size?: "default" | "small";
}

const GuideOpenTripCard: FC<GuideOpenTripCardProps> = ({
    size = "default",
    className = "",
    data = null,
    ratioClass,
}) => {
    const renderSliderGallery = (gal: any) => {

        return (
            <div className="relative w-full">
                <GallerySlider ratioClass={ratioClass} galleryImgs={gal} />

            </div>
        );
    };
    const history = useHistory();
    const dispatch = useDispatch();
    const [confimationModal, setConfirmationModal] = useState(false);
    const [tripId, settripId] = useState(0);
    const [tripState, settripState] = useState('');
    const [tripName, settripName] = useState('');
    const { t } = useTranslation();

    const updateStatus = async (id: any, state: any) => {
        let form = {
            'id': id,
            'state': state
        }

        let update = await updateStateTrip(form);

        dispatch(getGuideOpenTrip());
        setConfirmationModal(false);
        if (update.code === 200) {
            toast('Trips ' + state)
        } else {

        }

    }

    const renderContent = (data: IProduct) => {
        let dat = [
            { id: '1', name: 'Edit', icon: 'las la-edit' },
            { id: '2', name: data.state === 'archived' ? 'Publish' : 'Archive', icon: data.state === 'archived' ? 'las la-upload' : 'las la-archive' },
            { id: '3', name: 'Delete', icon: 'las la-trash' },
        ];

        if (data.state === 'draft') {
            dat = [
                { id: '1', name: 'Edit', icon: 'las la-edit' },
                { id: '2', name: 'Delete', icon: 'las la-trash' },
            ];
        }

        let now = moment();
        let dd = moment(Date.parse(data.startTripDate));
        let expired = dd.diff(now, 'days');
        let state = "";
        if (expired <= 0) {
            state = "( Expired )"
        }

        return (
            <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
                <NcModal
                    isOpenProp={confimationModal}
                    renderTrigger={() => { return (<div></div>); }}
                    hideCloseBtn={true}
                    // contentExtraClass="w-1/4"
                    modalTitle={t('confirmation')}
                    renderContent={() => {
                        return (
                            <div className="max-w-md">
                                <span className="text-center font-regular">
                                    {tripState === 'deleted' ? "Open " + t("confirm_update_delete", { name: tripName, state: tripState }) : "Open " + t("confirm_update_archive", { name: tripName, state: tripState })}
                                </span>
                                {tripState === 'deleted' && (
                                    <div style={{ justifyContent: 'center' }}>
                                        <span className="text-center font-light">{t("confirm_update_delete_desc")}</span>
                                    </div>
                                )}
                                <br />
                                <div className="flex flex-row w-full mt-8 space-x-4">
                                    <ButtonSecondary onClick={() => setConfirmationModal(false)} className="flex-1 p-2 h-min">No</ButtonSecondary>
                                    <ButtonPrimary onClick={() => {
                                        updateStatus(tripId, tripState)
                                    }} className="flex-1 w-full h-min p-2 ">
                                        Yes
                                    </ButtonPrimary>
                                </div>
                            </div>
                        );
                    }}

                />
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span className={`nc-Badge inline-flex px-2.5 py-1 rounded-full font-medium text-xs w-auto ml-2 ${data.state === "draft" ? "text-blue-800 bg-blue-100" : data.state === "published" ? "text-pink-800 bg-pink-100" : "text-purple-800 bg-purple-100"}  w-auto ml-2`} style={{ borderRadius: 10, padding: 5, fontSize: 12 }}>{data.state} {state}</span>
                    {/* <Link to={`/open-trip-add${data?.id ? `?id=${data.id}` : ''}`}
                        className="bg-primary-6000 text-white flex justify-center items-center"
                        style={{borderRadius:50, paddingRight:8, paddingLeft:8}}
                    >
                        <i className="las la-edit"></i>
                    </Link> */}
                    <NcDropDown data={dat} onClick={(item) => {
                        if (item.id === '1') {
                            history.push(`/open-trip-add${data?.id ? `?id=${data.id}` : ''}`)
                        } else {
                            settripId(data.id);
                            settripName(data.title);
                            if (item.id === '2') {
                                if (data.state === 'draft') {
                                    settripState('deleted');
                                } else if (data.state === 'archived') {
                                    settripState('published');
                                } else {
                                    settripState('archived');
                                }
                            } else {
                                settripState('deleted');
                            }
                            setConfirmationModal(true);
                        }
                    }} />
                </div>
                <div className="space-y-2">
                    <span className="text-sm text-neutral-500 dark:text-neutral-400">
                        {data?.startTripDate ? moment(data.startTripDate).format('MMMM Do YYYY') : ""} - {data?.endTripDate ? moment(data.endTripDate).format('MMMM Do YYYY') : ""}
                    </span>
                    <div className="flex items-center space-x-2">
                        <h2
                            className={` font-medium capitalize text-lg `}
                        >
                            <span className="line-clamp-1">{data?.title}</span>
                        </h2>
                    </div>
                    <div>
                        <span className="text-neutral-500 dark:text-neutral-400 text-sm  ">{data?.country ? (data?.country[0])?.name : ''}</span>
                        {
                            data?.productLocation &&
                            <Badge name={`${data?.productLocation.length} destinations`} className="w-auto ml-2 " color="green" />
                        }

                    </div>
                    <span className=" text-neutral-500 dark:text-neutral-400 text-sm ">{data?.highlight ?? "Add highlight"}</span><br />

                    <div className="flex  text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                            />
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.5}
                                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                        </svg>
                        <span className="">{data?.meetingAddress ?? 'Meeting address'}</span>
                    </div>
                    <div className="flex items-center text-neutral-500 dark:text-neutral-400 text-sm space-x-2">
                        <span className="">Guest : {data?.minGuest} - {data?.maxGuest}</span>

                    </div>
                    {data?.additionalContact ?
                        <span className="text-neutral-500 dark:text-neutral-400 text-sm space-x-2">Additional contact : {data?.additionalContact}</span>
                        : <></>}
                </div>
                <div className=" border-b border-neutral-100 dark:border-neutral-800"></div>
                <div className="flex justify-between items-center">
                    <span className="text-base font-semibold">
                        {currency(data?.totalPrice ? parseInt(data.totalPrice.toString()) : 0)}
                        <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                            / pax
                        </span>
                    </span>

                </div>
            </div>
        );
    };

    return (

        <div
            className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden hover:shadow-xl transition-shadow ${className}`}
            data-nc-id="StayCard"
        >
            {data != null ?
                <div>
                    {renderSliderGallery(data.file)}
                    {renderContent(data)}
                </div>
                : <></>}
        </div>
    );
};

export default GuideOpenTripCard;
